const getters = {
  sidebar: state => state.app.sidebar,
  visitedViews: state => state.app.visitedViews,

  username:state=>state.user.username,
  nickname: state => state.user.nickname,
  userId: state => state.user.userId,
  avatar: state => state.user.avatar,
  role: state => state.user.role,
  roleId:state=>state.user.roleId,
  menus: state => state.user.menus,
  permissions: state => state.user.permissions,
  phoneCheck:state=>state.user.phoneCheck,
  isManager:state=>state.user.isManager,
  roleType:state=>state.user.roleType,


  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters
}
export default getters
